import api from "./axiosInstance";

export const getCourseById = async (id) => {
  const { data } = await api.get(`/courses/${id}`);
  return data;
};
